import * as React from 'react';

function SvgCartOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M8.428 20.84a.804.804 0 100-1.608.804.804 0 000 1.608zM19.678 20.84a.804.804 0 100-1.608.804.804 0 000 1.608zM2 3.162h3.214l2.41 13.66h12.857" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M7.625 13.607h12.527a.402.402 0 00.394-.323l1.446-7.232a.401.401 0 00-.394-.48H6.018" })));
}

export default SvgCartOutline;
